import { h } from 'preact';
import { Dots } from './LoadingDots.styles';

const LoadingDots = () => {
  return (
    <Dots>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </Dots>
  );
};

export default LoadingDots;
